import { render } from "./Footer-TafiCloud.vue?vue&type=template&id=33e1e87f&scoped=true"
import script from "./Footer-TafiCloud.vue?vue&type=script&lang=js"
export * from "./Footer-TafiCloud.vue?vue&type=script&lang=js"

import "./Footer-TafiCloud.vue?vue&type=style&index=0&id=33e1e87f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e1e87f"]])

export default __exports__